export var NX_ENV = process.env.NX_ENV;
export var NX_PUBLIC_DASHBOARD_URL = process.env.NX_PUBLIC_DASHBOARD_URL;
